import type { CategoryImagesConfig } from '@iheartjane/types';

import defaultEdibleImage from './default-edible.png';
import defaultExtractImage from './default-extract.png';
import defaultFlowerImage from './default-flower.png';
import defaultGearImage from './default-gear.png';
import defaultGrowImage from './default-grow.png';
import defaultMerchImage from './default-merch.png';
import defaultPreRollImage from './default-pre-roll.png';
import defaultTinctureImage from './default-tincture.png';
import defaultTopicalImage from './default-topical.png';
import defaultVapeImage from './default-vape.png';

export const DEFAULT_CATEGORY_IMAGES: CategoryImagesConfig = {
  edible: defaultEdibleImage,
  extract: defaultExtractImage,
  flower: defaultFlowerImage,
  gear: defaultGearImage,
  grow: defaultGrowImage,
  merch: defaultMerchImage,
  'pre-roll': defaultPreRollImage,
  tincture: defaultTinctureImage,
  topical: defaultTopicalImage,
  vape: defaultVapeImage,
};
